import React from "react";
import { useState, useEffect } from "react";
import UseErrorItems from "./components/UseErrorItems";
import Table from "./components/Table";
import Header from "./components/Header";
import Modal from "./components/Modal";
import { Route, Routes } from "react-router-dom";

// The main app window visible for logged in users only
function App(props) {
  const [updateCounter, setUpdateCounter] = useState(0); // Keeps track of updates
  const dataItems = UseErrorItems(updateCounter); // Stores error register data
  const [backgroundBlur, setBackgroundBlur] = useState(false); // state of background blurring
  const today = new Date();
  const todayString = today.toISOString().slice(0,10);
  //console.log(updateCounter)
  const emptyModalData = {
    modalType: "",
    DocType: "",
    DocNumber: "",
    ProblemOrError: "",
    EmployeeInvolved: "",
    Description: "",
    DateReportedByManager: todayString,
    ApprovedSolution: "",
    People: [],
    canSubmit: false,
    CreatedByUser: props.user,
    currentUser: ""
  };
  const [modalData, setModalData] = useState(() => emptyModalData);

  // The state of options for sorting data
  const [sortSettings, setSortSettings] = useState({
    reverse: true, // The order of displayed rows
    by: "ID", // The column to sort rows by
  });

  const [deletedView, setDeletedView] = useState(false); // Display/hide deleted rows instead of active ones
  const [tableTypeText, setTableTypeText] = useState(true); // The heading showing the type of items displayed (active/deleted)

  const [appView, setAppView] = useState("table"); // The manner of showing data - in a table or in boxes etc.

  const blur = "blur(.5px)"; // Background blurring once the modal is displayed

  const [searchValue, setSearchValue] = useState(""); // Filter text entered in the Filter input box

  const modalProps = {
    modalData: modalData,
    setModalData: setModalData,
    update: updateCounter,
    setUpdate: setUpdateCounter,
    setBackgroundBlur: setBackgroundBlur,
    user: props.user,
    userType: props.userType,
  }

  // Handles filtering
  function handleSearchValue(e) {
    e.preventDefault();
    setSearchValue(e.target.value);
  }

  useEffect(() => {
    // Updates the table every n seconds by incrementing the update counter
    const seconds = 3;
    const updateInterval = setInterval(() => {
      setUpdateCounter((prevCounter) => prevCounter + 1);
    }, seconds * 1000);
    return () => {
      clearInterval(updateInterval); // Cleanup callback function
    };
  });

  
  /*useEffect(() => {
    console.log(modalData);
  }, [modalData]);*/

  // Sets view to deleted or active
  function showDeleted() {
    setDeletedView((prev) => !prev);
  }

  return (
    <div className="App">
      <div className="AppView">
        <div style={{ filter: backgroundBlur ? blur : "" }} className="appWrap">
          <Header
            setModalData={setModalData}
            emptyModalData={emptyModalData}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            userType={props.userType}
            handleSearchValue={handleSearchValue}
            showDeleted={showDeleted}
            setTableTypeText={setTableTypeText}
            setLoggedIn={props.setLoggedIn}
            view={appView}
            setView={setAppView}
          />
          <Table
            data={dataItems}
            user={props.user}
            userType={props.userType}
            setSort={setSortSettings}
            sort={sortSettings}
            searchValue={searchValue}
            tableTypeText={tableTypeText}
            deletedView={deletedView}
            view={appView}
            modalProps={modalProps}
          />
        </div>
        <Routes>
          <Route
            path="modal"
            element={
              <Modal 
                main={modalProps}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
}
export default App;
